<template>
  <v-row>
    <v-col>
      <v-row dense justify="end" class="mr-3">
        <v-col cols="auto">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="saveUserPermissions" v-on="on" :attrs="attrs">
                ri-checkbox-line
              </v-icon>
            </template>
            <span>Marcar tudo</span>
          </v-tooltip>
        </v-col>
        <v-col cols="auto">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="deleteUserPermissions" v-on="on" :attrs="attrs">
                ri-checkbox-blank-line
              </v-icon>
            </template>
            <span>Desmarcar tudo</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row>{{unitId}}</v-row>
      <v-list v-if="unitId">
        <template v-for="(permission, index) in filteredPermissions">
          <v-list-item :key="permission.key" :ripple="false">
            <v-list-item-content>
              <v-list-item-title v-text="permission.key" />
            </v-list-item-content>

            <v-list-item-icon>
              <v-checkbox
                v-for="can in permission.can"
                :key="can"
                :label="can"
                dense
                hide-details
                :input-value="permissionCheck(permission.key, can)"
                @change="saveUserPermission(permission.key, can)"
                class="mt-0 ml-3"
              />
            </v-list-item-icon>
          </v-list-item>

          <v-divider
            v-if="index < filteredPermissions.length - 1"
            :key="index"
          ></v-divider>
        </template>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    permissions: Array,
    user: Object,
    unitId: String,
    category: String,
    refreshUser: Function,
  },
  computed: {
    userPermissions() {
      return this.user.permissions;
    },
    filteredPermissions() {
      return this.lodash.filter(this.permissions, { category: this.category });
    },
  },
  methods: {
    permissionCheck(permissionKey, can) {
      let userPermission = this.lodash.find(this.userPermissions, {
        permissionKey: permissionKey,
        unit: { id: this.unitId }
      });

      if (!userPermission) return false;

      return this.lodash.indexOf(userPermission.can, can) > -1;
    },
    saveUserPermission(permissionKey, can) {
      return this.apolloMutate({
        mutation: require("@/graphql/user_permission/save_user_permission.gql"),
        variables: {
          userId: this.user.id,
          unitId: this.unitId,
          permissionKey: permissionKey,
          canKey: can,
          canValue: !this.permissionCheck(permissionKey, can),
        },
      }).then(() => {
        this.refreshUser();
      });
    },
    saveUserPermissions() {
      return this.apolloMutate({
        mutation: require("@/graphql/user_permission/save_user_permissions.gql"),
        variables: {
          userId: this.user.id,
          unitId: this.unitId,
          category: this.category,
        },
      }).then(() => {
        this.refreshUser();
      });
    },
    deleteUserPermissions() {
      return this.apolloMutate({
        mutation: require("@/graphql/user_permission/delete_user_permissions.gql"),
        variables: {
          userId: this.user.id,
          unitId: this.unitId,
          category: this.category,
        },
      }).then(() => {
        this.refreshUser();
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
